import './testimonial-slider.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';

class TestimonialSlider {
    constructor ($element) {
        this.$testimonialSlider = $element;
        this.$testimonialSliderSingleView = this.$testimonialSlider.dataset.testimonialSliderSingleView;
        this.$testimonialSliderInstanz = this.$testimonialSlider.querySelector('[data-testimonial-slider="slider"]');
        this.$slides = this.$testimonialSliderInstanz.querySelectorAll('.swiper-slide');
        this.$prevButton = null;
        this.$nextButton = null;
        this.$pagination = null;
        this.slider = null;

        this.prevSlideMessage = window.TRANSLATIONS.SLIDER.PREV_SLIDE_MESSAGE;
        this.nextSlideMessage = window.TRANSLATIONS.SLIDER.NEXT_SLIDE_MESSAGE;
        this.firstSlideMessage = window.TRANSLATIONS.SLIDER.FIRST_SLIDE_MESSAGE;
        this.lastSlideMessage = window.TRANSLATIONS.SLIDER.LAST_SLIDE_MESSAGE;
        this.slideLabel = window.TRANSLATIONS.SLIDER.SLIDE_LABEL;
        this.slideLabelFrom = window.TRANSLATIONS.SLIDER.SLIDE_LABEL_FROM;

        this.initialize();
    }

    initialize () {
        if (this.$testimonialSliderSingleView && this.$slides.length > 1) {
            this.initSlider();
        } else {
            if (this.$slides.length > 1 && this.$slides.length < 4) {
                this.checkSize();
                this.setEvents();
            }

            if (this.$slides.length > 1) {
                this.initSlider();
            }
        }
    }

    checkSize () {
        if (window.mediaMatchHandler[1440].matches) {
            this.destroySlider();
        } else {
            if (this.slider === null) {
                this.initSlider();
            }
        }
    }

    setEvents () {
        [1024, 768, 320].forEach((bp) => {
            window.mediaMatchHandler[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    initSlider () {
        this.$prevButton = this.$testimonialSlider.querySelector('[data-slider="prev"]');
        this.$nextButton = this.$testimonialSlider.querySelector('[data-slider="next"]');
        this.$pagination = this.$testimonialSlider.querySelector('[data-slider="pagination"]');

        this.slider = new Swiper(this.$testimonialSliderInstanz, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 'auto',
            lazyPreloadPrevNext: true,
            autoHeight: true,
            speed: 500,
            watchSlidesProgress: true,
            a11y: {
                prevSlideMessage: this.prevSlideMessage,
                nextSlideMessage: this.nextSlideMessage,
                firstSlideMessage: this.firstSlideMessage,
                lastSlideMessage: this.lastSlideMessage,
                slideLabelMessage: `${this.slideLabel} {{index}} ${this.slideLabelFrom} {{slidesLength}}`,
            },
            pagination: {
                el: this.$pagination,
                type: 'bullets',
                clickable: false
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            keyboard: true,
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

export { TestimonialSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$TestimonialSlider = $context.querySelectorAll('[data-testimonial-slider="root"]');

    if ($$TestimonialSlider.length > 0) {
        $$TestimonialSlider.forEach(($TestimonialSlider) => {
            const testimonialSlider = new TestimonialSlider($TestimonialSlider); // eslint-disable-line
        });
    }
});